export enum ForumTypeEnum {
    THREAD = 'thread',
    TOPIC = 'topic'
}

export interface ForumUser {
    userId: string
    firstname: string
    lastname: string
    nickname?: string
    attachment?: {url: string}
    avatarImage?: string
    disabled?: boolean
}
export interface Thread {
    _id: string
    title: string
}
